import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import TourGuideInner from '../Components/Guide/TourGuideInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { usePageBanner } from '../hooks/usePageBanner'

function TourGuide() {
  const { title, bgImage } = usePageBanner({
    pageSlug: 'tour-guide',
    fallbackTitle: 'Tour Guide',
  })

  return (
    <>
      <HeaderOne />
      <Breadcrumb title={title} bgImage={bgImage} />
      <TourGuideInner />
      <FooterFour />
      <ScrollToTop />
    </>
  )
}

export default TourGuide
